// extracted by mini-css-extract-plugin
module.exports = {"tdStyle":"_3BlC_"};